import React from "react";
import NumberFormat from "react-number-format";
import Helper from "./Helper";

class ProductRelateItem extends React.Component {
  addToCart = (item)=>{
    item['category'] = item.meta.category;
    item['price_after_discount'] = item.meta.price_after_discount;
    item['product_id'] = item.id;
    this.props.addToCart(item);
  }
  render() {
    let { product } = this.props;
    let rating = product.meta.rating_amount??0,
    rating_view = [];
    for (let i = 0; i < 5; i++) {
        let act = rating >= (i+1) ? 'act' : 'dis';
        rating_view.push(
        <span key={i} className={act}>
          <i className="fas fa-star" />
        </span>);
    }
    return (
      <div className="product-wrap__item swiper-slide">
        <div className="product-style1 p-2 p-lg-4 w-100">
          <div className="product-style1__thumbnail position-relative w-100 mb-md-1">
            <a href={product.link}>
              <img
                src={product.image}
                alt={product.title}
                className="img-fluid"
              />
            </a>
            {product.meta.discount ? (
              <span className="position-absolute product-style1__discount">
                {product.meta.discount <= 1 ? (
                  `${Math.ceil(product.meta.discount * 100)}%`
                ) : (
                  <NumberFormat
                    value={product.meta.discount}
                    thousandSeparator="."
                    decimalSeparator=","
                    displayType={"text"}
                    renderText={(value) => `-${value}đ`}
                  />
                )}
              </span>
            ) : null}
            {product.meta.out_of_stock ? (
              <span className="product-style1__out-of-stock">Cháy hàng</span>
            ) : null}
          </div>
          <div className="product-style1__text text-left px-md-2">
            <h3 className="product-style1__text__heading">
            <a className="product-style1__text__title" href={product.link}>
              {Helper.wordLimiter(product.title, 12)}
            </a>
            </h3>
            <p className="product-style1__text__price font-weight-bold">
              <NumberFormat
                value={product.meta.price_after_discount}
                thousandSeparator="."
                decimalSeparator=","
                displayType={"text"}
                renderText={(value) => `${value}đ`}
              />
            </p>
            {product.meta.price > product.meta.price_after_discount ? (
              <p className="product-style1__text__price-origin">
                <NumberFormat
                  value={product.meta.price}
                  thousandSeparator="."
                  decimalSeparator=","
                  displayType={"text"}
                  renderText={(value) => `${value}đ`}
                />
              </p>
            ) : null}
            <p className="product-style1__text__rating d-flex">
              {rating_view}
              <span className="rating-count text-warning">({product.meta.count_rating})</span>
            </p>
          </div>
        </div>
      </div>
    );
  }
}
export default ProductRelateItem;
